interface IParsedStreetAddress {
    streetName: string;
    suite: string;
    civicNumber: string;
}

class AddressHelper {
    public static addressParsingRegex = [
        /^(?:(?<suite>\d+)-)?(?<civicNumber>\d+[a-zA-Z]?)(?: |, *)(?<streetName>[^\d]+)(?<suite2>\d+)?$/,
        /^(?:(?<suite>\d+)-)?(?<civicNumber>\d+[a-zA-Z]?)(?: (.*))(?<streetName>[^\d]+)(?<suite2>\d+)?$/
    ];

    public static parseStreetAddress(streetAddress: string): IParsedStreetAddress {
        const streetAddressTrimmed = streetAddress?.trim();
        if (!streetAddressTrimmed)
            return null;

        let match: RegExpExecArray = null;
        for (let regex of this.addressParsingRegex) {
            if (regex.test(streetAddressTrimmed)) {
                match = regex.exec(streetAddressTrimmed);
                break;
            }
        }

        if (!match)
            return null;

        const groups = match.groups;
        return {
            streetName: (groups?.["streetName"] || "").replace(/,? *(bureau|suite)/gi, "")?.trim(),
            suite: (groups?.["suite"] ?? groups?.["suite2"])?.trim(),
            civicNumber: (groups?.["civicNumber"])?.trim()
        };
    }
}

export { AddressHelper };
